import React from 'react'
import Heroabout from '../components/Heroabout';
import Mission from '../components/Mission';
import Footer from '../components/Footer';

const Company = () => {
  return (
    <section className='flex flex-col'>
        <Heroabout />
        <Mission />
      <Footer />
    </section>
  )
}
export default Company;